'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('../utils/underscore');

var _immutable = require('immutable');

var _reactUtils = require('react-utils');

exports.default = {
  componentWillMount: function componentWillMount() {
    this._partials = (0, _immutable.Map)();
  },
  componentWillUnmount: function componentWillUnmount() {
    this._partials = null;
  },
  partial: function partial(func) {
    (0, _reactUtils.invariant)(typeof func === 'function', '%s.partial: expected `func` to be a function but got `%s`.', this.constructor.displayName, func);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var keyList = _immutable.List.of.apply(_immutable.List, [func].concat(args));
    if (!this._partials.has(keyList)) {
      this._partials = this._partials.set(keyList, _underscore.partial.apply(undefined, [func].concat(args)));
    }
    return this._partials.get(keyList);
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/mixins/ComponentWithPartials.js
// module id = 152
// module chunks = 0